import React from 'react';
import { SectionHeading } from '../components/ui/SectionHeading';
import { ScrollReveal } from '../components/ui/ScrollReveal';
import { Button } from '../components/ui/Button';
import { ConceptCard } from '../components/ui/ConceptCard';
export function ResidentialPage() {
  return <div className="w-full pt-24" data-id="element-856">
      {/* Hero */}
      <section className="py-24 md:py-32 bg-brand-green-deep text-brand-cream-light relative overflow-hidden" data-id="element-857">
        <div className="absolute inset-0 bg-concept-estate opacity-40 mix-blend-overlay" data-id="element-858" />
        <div className="max-w-7xl mx-auto px-6 relative z-10" data-id="element-859">
          <SectionHeading eyebrow="Residential" title="Luxury putting environments for the modern estate." subtitle="Elevate how you entertain, unwind, and enjoy your property with a custom-designed golf experience." light data-id="element-860" />
        </div>
      </section>

      {/* Why Add */}
      <section className="py-24 bg-brand-cream-light" data-id="element-861">
        <div className="max-w-7xl mx-auto px-6" data-id="element-862">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-863">
            <ScrollReveal data-id="element-864">
              <h2 className="text-4xl font-heading text-brand-green-deep mb-6" data-id="element-865">
                More than landscaping. An amenity.
              </h2>
              <p className="text-lg font-body text-brand-stone mb-6" data-id="element-866">
                A PuttLab residential green isn't just turf in the backyard.
                It's a designed architectural feature that adds prestige,
                entertainment value, and a focal point for family and guests.
              </p>
              <ul className="space-y-4 font-body text-brand-charcoal" data-id="element-867">
                <li className="flex items-start" data-id="element-868">
                  <span className="text-brand-gold mr-3" data-id="element-869">✦</span> Premium
                  outdoor living extension
                </li>
                <li className="flex items-start" data-id="element-870">
                  <span className="text-brand-gold mr-3" data-id="element-871">✦</span>{' '}
                  Multi-generational family entertainment
                </li>
                <li className="flex items-start" data-id="element-872">
                  <span className="text-brand-gold mr-3" data-id="element-873">✦</span> High-end
                  property value addition
                </li>
                <li className="flex items-start" data-id="element-874">
                  <span className="text-brand-gold mr-3" data-id="element-875">✦</span>{' '}
                  Zero-maintenance luxury aesthetic
                </li>
              </ul>
            </ScrollReveal>
            <ScrollReveal direction="left" data-id="element-876">
              <div className="aspect-square bg-gradient-to-br from-brand-sand to-brand-stone rounded-sm opacity-80" data-id="element-877" />
            </ScrollReveal>
          </div>
        </div>
      </section>

      {/* Concept Gallery */}
      <section className="py-24 bg-brand-cream" data-id="element-878">
        <div className="max-w-7xl mx-auto px-6" data-id="element-879">
          <SectionHeading title="Residential Concepts" className="mb-16" data-id="element-880" />
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-881">
            <ConceptCard title="The Estate Green" description="Expansive, multi-hole designs that mimic private club practice facilities." gradientClass="bg-concept-estate" imageUrl="https://cdn.magicpatterns.com/uploads/3b62EKAAjmaPYQxrkuwQqy/estategreen.png" data-id="element-882" />
            <ConceptCard title="The Social Green" description="Integrated with fire pits, seating, and outdoor kitchens for evening entertaining." gradientClass="bg-concept-social" imageUrl="https://cdn.magicpatterns.com/uploads/27Tjnbykmz8BtCjWmDRoGL/socialgreen.png" data-id="element-883" />
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-24 bg-brand-green text-brand-cream-light text-center" data-id="element-884">
        <div className="max-w-3xl mx-auto px-6" data-id="element-885">
          <h2 className="text-4xl font-heading mb-8" data-id="element-886">
            Ready to transform your property?
          </h2>
          <Button variant="primary" size="lg" href="/contact" data-id="element-887">
            Inquire About Residential Design
          </Button>
        </div>
      </section>
    </div>;
}